<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Trasfer Ayarı</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/transferConfigs'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Trasfer Ayarı Ekle
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <!--begin::Form-->
          <form class="m-form m-form--fit m-form--label-align-right">
            <div class="m-portlet">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Entegrasyon Servisi Adı</label>
                    <input
                      type="text"
                      :class="{ 'is-invalid': $v.item.name.$error }"
                      v-model="item.name"
                      class="form-control m-input"
                      placeholder="Entegrasyon servisi kodunu giriniz."
                    />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Entegrasyon</label>
                    <select
                      :class="{ 'is-invalid': $v.item.gatewayId.$error }"
                      v-model="item.gatewayId"
                      class="form-control m-input"
                      placeholder="Entegrasyon Seçiniz."
                    >
                      <option
                        v-for="option in gateways"
                        v-bind:value="option.id"
                        v-bind:key="option.description"
                      >{{ option.description }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Transfer Tipi</label>
                    <select
                      :class="{ 'is-invalid': $v.item.type.$error }"
                      v-model="item.type"
                      class="form-control m-input"
                      placeholder="Transfer Tipi."
                    >
                      <option
                        v-for="option in types"
                        v-bind:value="option.id"
                        v-bind:key="option.name"
                      >{{ option.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Kaynak</label>
                    <select
                      :class="{ 'is-invalid': $v.item.source.$error }"
                      v-model="item.source"
                      class="form-control m-input"
                      placeholder="Kaynak."
                    >
                      <option
                        v-for="option in connectors"
                        v-bind:value="option.id"
                        v-bind:key="option.name"
                      >{{ option.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Hedef</label>
                    <select
                      :class="{ 'is-invalid': $v.item.target.$error }"
                      v-model="item.target"
                      class="form-control m-input"
                      placeholder="Hedef."
                    >
                      <option
                        v-for="option in connectors"
                        v-bind:value="option.id"
                        v-bind:key="option.name"
                      >{{ option.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Durum</label>
                    <select
                      :class="{ 'is-invalid': $v.item.status.$error }"
                      v-model="item.status"
                      class="form-control m-input"
                      placeholder="Durum."
                    >
                      <option
                        v-for="option in status"
                        v-bind:value="option.id"
                        v-bind:key="option.name"
                      >{{ option.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Çalışma Aralığı</label>
                    <input
                      type="text"
                      :class="{ 'is-invalid': $v.item.interval.$error }"
                      v-model.number="item.interval"
                      class="form-control m-input"
                      placeholder="Çalışma aralığı"
                    />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Bir sonraki çalışma zamanı</label>
                    <datepicker
                      type="text"
                      format="dd.MM.yyyy"
                      input-class="form-control"
                      :class="{ 'is-invalid': $v.item.nextScheduleDate.$error }"
                      v-model="item.nextScheduleDate"
                      placeholder="Bir sonraki çalışma zamanı "
                    ></datepicker>
                  </div>
                </div>
              </div>
            </div>
            <!--begin::Portlet-->
            <div class="m-portlet">
              <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                  <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">Parametreler</h3>
                  </div>
                </div>

                <div class="m-portlet__head-tools">
                  <ul class="m-portlet__nav">
                    <li class="m-portlet__nav-item">
                      <button
                        @click="addNewEmptyParam()"
                        class="spbtn"
                        type="button"
                      >
                        <span>
                          <i class="la la-plus"></i>
                          <span>Yeni Parametre Ekle</span>
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="m-portlet__body">
                <div class="table-responsive">
                  <!--begin::Table-->
                  <table class="table">
                    <!--begin::Thead-->
                    <thead>
                      <tr>
                        <td class="m-widget11__label">#</td>
                        <td class="m-widget11__app">PARAMETRE</td>
                        <td class="m-widget11__app">ZAMAN FILTRESI?</td>
                        <td class="m-widget11__app">OPERATÖR</td>
                        <td class="m-widget11__app">DEĞER</td>
                        <td></td>
                      </tr>
                    </thead>

                    <!--end::Thead-->

                    <!--begin::Tbody-->
                    <tbody v-if="params && params.length">
                      <tr v-for="(v, index) in $v.params.$each.$iter" v-bind:key="index">
                        <td>0</td>
                        <td>
                          <input
                            type="text"
                            class="form-control m-input"
                            placeholder="Parametre"
                            :class="{
                              'is-invalid':
                                !v.parameter.required
                            }"
                            v-model="v.parameter.$model"
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            class="form-control m-input"
                            placeholder="Zaman Filtresi mi?"
                            v-model="v.isRelativeTimeFilter.$model"
                          />
                        </td>
                        <td>
                          <select
                            class="form-control m-input"
                            :class="{
                              'is-invalid':
                               !v.operator.required
                            }"
                            v-model="v.operator.$model"
                          >
                            <option value="null">Seçiniz</option>
                            <option
                              v-for="option in operators"
                              :key="option.id"
                              :value="option.id"
                            >{{ option.name }}</option>
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control m-input"
                            placeholder="Değer"
                            :class="{
                              'is-invalid':
                                !v.value.required
                            }"
                            v-model="v.value.$model"
                          />
                        </td>

                        <td>
                          <button
                            @click="deleteDetailItem(v.$model)"
                            class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill btn-lg"
                            title="Sil"
                          >
                            <i class="la la-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>

                    <!--end::Tbody-->
                  </table>

                  <!--end::Table-->
                </div>
              </div>

              <!--end::Form-->
            </div>
            <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
              <div class="m-form__actions m-form__actions--solid">
                <div class="row">
                  <div class="col-lg-12">
                    <button
                      type="button"
                      @click="item.id==0?create():update()"
                      class="spbtn"
                    >Kaydet</button>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <!--end::Form-->
        </div>

        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength, decimal } from "vuelidate/lib/validators";
import {
  _createTransferConfiguration,
  _updateTransferConfiguration,
  _getTransferStatus,
  _getTransferConnectors,
  _getTransferTypes,
  _getTransferConfigurationById,
  _getAllGatewayCombo,
  _getTransferOperators,
  _updateTransferConfigurationParameter,
  _getTransferConfigurationParameterByConfigurationId
} from "../../services/GatewayService";
import datepicker from "vuejs-datepicker";

export default {
  created() {
    if (Number(this.$route.params.id) != 0) {
      this.item.id = Number(this.$route.params.id);
      this.getById();
     this.getParams();
    }
    this.getConnetors();
    this.getTypes();
    this.getStatus();
    this.getGateways();
    this.getOperators();
  },
  components: {
    datepicker: datepicker
  },
  data() {
    return {
      item: {
        id: 0,
        gatewayId: null,
        name: "",
        type: null,
        source: null,
        target: null,
        interval: null,
        status: null,
        nextScheduleDate: null
      },
      params: [],
      status: [],
      types: [],
      connectors: [],
      gateways: [],
      operators: []
    };
  },
  validations: {
    item: {
      name: { required },
      gatewayId: { required },
      type: { required },
      source: { required },
      target: { required },
      interval: { decimal },
      status: { required },
      nextScheduleDate: { required }
    },
    params: {
      $each: {
        parameter: { required },
        value: { required },
        operator: { required },
        isRelativeTimeFilter: { required }
      }
    }
  },
  methods: {
    create: function() {
      this.$v.item.$touch();
      this.$v.params.$touch();
      if (this.$v.item.$error || this.$v.params.$error) return;
      _createTransferConfiguration(this.item).then(response => {
        if (response.data.success) {
          this.item.id = response.data.data;
          this.updateParams();
        }
      });
    },
    update: function() {
      this.$v.item.$touch();
      this.$v.params.$touch();
      if (this.$v.item.$error || this.$v.params.$error) return;

      _updateTransferConfiguration(this.item).then(response => {
        if (response.data.success) {
          this.updateParams();
        }
      });
    },
    getById: function() {
      _getTransferConfigurationById(Number(this.$route.params.id)).then(
        response => {
          if (response.data.success) this.item = response.data.data;
          else this.$router.push({ name: "transferConfigs" });
        }
      );
    },
    getStatus: function() {
      _getTransferStatus().then(response => {
        this.status = response.data;
      });
    },
    getTypes: function() {
      _getTransferTypes().then(response => {
        this.types = response.data;
      });
    },
    getConnetors: function() {
      _getTransferConnectors().then(response => {
        this.connectors = response.data;
      });
    },
    getGateways: function() {
      _getAllGatewayCombo().then(response => {
        this.gateways = response.data.data;
      });
    },
    getOperators: function() {
      _getTransferOperators().then(response => {
        this.operators = response.data;
      });
    },
    addNewEmptyParam() {
      this.params.push({
        parameter: null,
        value: null,
        operator: null,
        isRelativeTimeFilter: false
      });
    },
    deleteDetailItem(item) {
      this.params.splice(this.params.indexOf(item), 1);
    },
    updateParams() {
      var model = {
        transferConfigurationId: this.item.id,
        items: this.params
      };
      _updateTransferConfigurationParameter(model).then(res => {
        if (res.data.success) this.$router.push({ name: "transferConfigs" });
      });
    },
    getParams(){
      _getTransferConfigurationParameterByConfigurationId(this.item.id).then(res=>{
        if(res.data.success)
        this.params=res.data.data.items;
      });
    }
  }
};
</script>